module.exports = __webpack_public_path__ + "static/img/4.3a1b1cb6.png";